export const CLIENT_ERROR = "CLIENT_ERROR"
export const CLIENT_STATUS = "CLIENT_STATUS"
export const CLIENT_RESPONSE = "CLIENT_RESPONSE"
export const CLIENT_STATUS_TEXT = "CLIENT_STATUS_TEXT"

export const SERVER_SHOW_OVERLAY = "SERVER_SHOW_OVERLAY"
export const SERVER_STATUS = "SERVER_STATUS"
export const SERVER_RESPONSE = "SERVER_RESPONSE"
export const SERVER_STATUS_TEXT = "SERVER_STATUS_TEXT"
export const SERVER_OVERLAY_MESSAGE = "SERVER_OVERLAY_MESSAGE"
export const SERVER_OVERLAY_FUNCTION = "SERVER_OVERLAY_FUNCTION"


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/httpRequests/types.js
// module id = null
// module chunks = 